module.exports = __webpack_public_path__ + "static/img/link1.f00e2ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/web/link1.png
// module id = aV1F
// module chunks = 0